var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EB4748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.34 12.602s-.159-1.168-.69-1.7c-.637-.69-1.381-.69-1.7-.743C19.56 10 16 10 16 10s-3.56 0-5.95.16c-.319.052-1.062.052-1.7.743-.531.53-.69 1.699-.69 1.699s-.16 1.38-.16 2.76v1.275c0 1.38.16 2.761.16 2.761s.159 1.168.69 1.7c.638.69 1.488.637 1.86.743C11.59 21.947 16 22 16 22s3.56 0 5.95-.16c.319-.052 1.063-.052 1.7-.743.531-.53.69-1.699.69-1.699s.16-1.38.16-2.76v-1.275c0-1.38-.16-2.761-.16-2.761M14.248 18.23v-4.779l4.569 2.39-4.57 2.39"
  })));
};
export default SvgYoutubeinline;